import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';

let body1 = '{ "product":"CARBONATO DE LITIO", "input":"usfob", "company":"SQM", "calcmt":"original", "frecuency":"month", "datefrom":"2017-01-01", "dateto":"2018-12-31", "origin":"CHILE","destiny":"" }';

@Component({
  selector: 'app-grafico',
  templateUrl: './grafico.component.html',
  styleUrls: ['./grafico.component.sass'],
  providers: [AppService]
})
export class GraficoComponent implements OnInit {
  title="Li2Co3 SQM-Chile-All"
  chartData = body1;
  data: any = []
  usfob: number[] = []
  tonnes: number[] = []
  public labels: string[] =[]
  isDataAvailable: boolean =false;

  constructor(public appService: AppService) { }

  ngOnInit() {
  }
  public pieChartLabels:string[] =[];
  public pieChartType:string = 'line';
  public pieChartData:any[] = [];

  public pieChartOptions:any = {
    'backgroundColor': ["#FF6384", "#4BC0C0","#FFCE56","#E7E9ED","#36A2EB"],
    responsive: true,
        scales: {
        yAxes: [{
          type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
          display: true,
          scaleLabel: {
            display: true,
            labelString: 'MT (Million Tonnes)'
          },
          position: 'left',
          id: 'y-axis-1',
        } //, {
        //   type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
        //   display: true,
        //   scaleLabel: {
        // 		display: true,
        // 		labelString: 'US$'
        // 	},
        //   position: 'right',
        //   id: 'y-axis-2',
        //
        //   // grid line settings
        //   gridLines: {
        //     drawOnChartArea: false, // only want the grid lines for one axis to show up
        //   },
         ],
      } };


/* method to call get-api from app.service */
  AuthorsPage(body) {
    try {
      this.appService.getGraphData(body)
        .subscribe(resp => {
          console.log(resp, "res");
          this.data = resp;
          this.GetData(body);
          this.isDataAvailable = true;
        },
          error => {
            console.log(error, "error");
          })
    }

     catch (e) {
      console.log(e);
    }

  }

  GetData(body) {
    this.pieChartData = [{label: '', data:[], yAxisID: 'y-axis-1', }];
    this.labels =[]
    this.usfob = []
    this.tonnes = []
    var i=0;
    for (let entry of this.data) {
      if (entry.month) {
        this.labels[i] = entry.year+"-"+entry.month;
      }
      else if (entry.quarter) {
        this.labels[i] = entry.year+" Q-"+entry.quarter;
      }
      else {
        this.labels[i] = entry.year;
      }
      this.usfob[i] = entry.usfob/1000000;
      //this.usfob[i] = Number( entry.usfob.replace(/[^0-9,-]+/g,"").replace(",",".") ); //entry.usfob.replace(/[$.]+/g,"");
      this.tonnes[i] = entry.tonnes;
      i=i+1;
    }
    if (body.input==="tonnes") {
      this.pieChartData[0].label="MT (Million Tonnes)";
      this.pieChartData[0].data= this.tonnes;
    }
    else  {
      this.pieChartData[0].data= this.usfob;
      this.pieChartData[0].label="MM USFOB";
    }

    //console.log(this.labels);
    console.log(this.usfob);
    console.log(this.pieChartData);

  }

  rDataGrafico(data :any) {
    this.isDataAvailable = true;
    this.chartData = JSON.stringify(data);
    console.log(data);
    // this.pieChartType= data.charttype;
    //
    // if (data.input ==="usfob") {
    //   this.pieChartOptions.scales.yAxes[0].scaleLabel.labelString = "MM US$FOB";
    //   this.pieChartData[0].label="MM US$FOB";
    // }
    // else if (data.input==="tonnes") {
    //   this.pieChartOptions.scales.yAxes[0].scaleLabel.labelString = "MT(Million Tonnes)";
    //   this.pieChartData[0].label=" MT(Million Tonnes)";
    // }
    // this.isDataAvailable = false;
    // this.AuthorsPage(data);
    //this.pieChartData = data;
  }
}
